<section fxLayout="column" fxFlexAlign="stretch">
  <div class="header" fxLayout="row" fxLayoutAlign="stretch" fxLayoutGap="10px">
    <!-- <p class="headlineDiv">{{'COMPONENTS.MODULEONBOARDINGTAB.TITLE' | i18next }}</p> -->
  </div>

  <div class="connectionState" fxLayout="row" fxFlexAlign="center">
    <div class="actionList" fxLayout="row" fxFlexAlign="stretch" *ngFor="let a of actionList">
      <div fxLayout="column" [ngClass]="{'actiondivstart': a.id === 1, 'actiondivend': a.id === 6, 'actiondivmiddle': a.id < 6 && a.id > 1}">
        <p class="generellTxt correctTextPosition" [ngClass]="{'actiontextstart': a.id === 1, 'actiontextend': a.id === 6, 'actiontextmiddle': a.id < 6 && a.id > 1}">{{a.action | i18next}}</p>
        <div [ngSwitch]="a.id">
          <div *ngSwitchCase="1" class="actionSvgContainer">
            <img *ngIf="a.state === 0" class="actionimgStart correctMargin progressIcon " src="/assets/stepIcon_start_b.svg">
            <img *ngIf="a.state === 1" class="actionimgStart correctMargin progressIcon " src="/assets/stepIcon_start_d.svg">
            <img *ngIf="a.state >= 2" class="actionimgStart correctMargin progressIcon " src="/assets/stepIcon_start_r.svg">
          </div>
          <div *ngSwitchCase="6" class="actionSvgContainer">
            <img *ngIf="a.state === 0" class="actionimgEnd correctMarginEnd progressIcon " src="/assets/stepIcon_end_b.svg">
            <img *ngIf="a.state === 1" class="actionimgEnd correctMarginEnd progressIcon " src="/assets/stepIcon_end_d.svg">
            <img *ngIf="a.state >= 2" class="actionimgEnd correctMarginEnd progressIcon" src="/assets/stepIcon_end_r.svg">
          </div>
          <div *ngSwitchDefault class="actionSvgContainer">
            <img *ngIf="a.state === 0" class="actionimgMiddle progressIcon " src="/assets/stepIcon_middle_b.svg">
            <img *ngIf="a.state === 1" class="actionimgMiddle progressIcon " src="/assets/stepIcon_middle_d.svg">
            <img *ngIf="a.state >= 2" class="actionimgMiddle progressIcon " src="/assets/stepIcon_middle_r.svg">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="filterdiv" fxLayout="row" fxFlexAlign="stretch" *ngIf="!_modulePlan.customerModule.SerialNumberSetted">
    <div fxLayout="column" class="serialselection">
      <!-- UserSelection!-->
      <p class="filterheadertext">{{'COMPONENTS.MODULEONBOARDINGTAB.SELECTSERIAL' | i18next }}</p>
      <div fxLayout="column"  fxFlexAlign="center" class="downscrollarrow flipArrow">
        <button mat-button class="arrowbtn" (click)="ScrollUp()" *ngIf="UpScrolling()">
          <img src="/assets/general/arrow_scroll.svg">
        </button>
      </div>
      <div class="seriallist" #serialContainer>
        <mat-list *ngFor="let ser of _serialNumbers" #serialList>
          <div fxLayout="row" fxFlexAlign="center">

            <div fxLayout="row" fxFlexAlign="center" class="serialcontainer" (click)="SelectSerial(ser.SerialNumber)">
              <p class="serialelement" >{{ser.SerialNumber}}</p>
              <svg class="isOnlineSvg" *ngIf="ser.NetworkAvailable" xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24">
                <g>
                  <path id="path1" transform="rotate(0,12,12) translate(0,2.99963343182792) scale(0.749999195338159,0.749999195338159)  " fill="white" d="M15.927021,17.931004C17.584003,17.931004 18.927021,19.290011 18.927021,20.966004 18.927021,22.641997 17.584003,24.001004 15.927021,24.001004 14.270039,24.001004 12.927021,22.641997 12.927021,20.966004 12.927021,19.290011 14.270039,17.931004 15.927021,17.931004z M16.020968,12.330998C18.468986,12.330998 20.790003,13.497001 22.557015,15.615006 22.911018,16.040007 22.853018,16.670009 22.430015,17.024009 22.242014,17.18001 22.016012,17.25601 21.79001,17.25601 21.503008,17.25601 21.219006,17.13301 21.021005,16.897009 19.640995,15.242005 17.864981,14.331003 16.020968,14.331003 14.242955,14.331003 12.514942,15.187005 11.154932,16.740009 10.788929,17.15601 10.156925,17.19701 9.7439218,16.835009 9.3279188,16.471008 9.2859185,15.839006 9.6489213,15.424005 11.393934,13.429 13.656951,12.330998 16.020968,12.330998z M16.020306,6.197011C20.150259,6.197011 24.103215,8.1410112 27.152182,11.673012 27.513178,12.091012 27.466178,12.722013 27.048182,13.083013 26.860185,13.246013 26.626187,13.326013 26.39519,13.326013 26.115193,13.326013 25.835196,13.209013 25.638198,12.979013 22.975228,9.8950119 19.559266,8.197011 16.020306,8.197011 12.550345,8.197011 9.1863821,9.8370123 6.5464115,12.814013 6.1794157,13.228013 5.5474229,13.264013 5.1354275,12.899013 4.7224321,12.533013 4.684432,11.901012 5.0504284,11.487012 8.0753946,8.0760117 11.970351,6.197011 16.020306,6.197011z M16.020912,0C21.831923,0 27.417933,2.7169971 31.750942,7.6519928 32.115942,8.0669928 32.074942,8.6989918 31.659943,9.0629911 31.244942,9.4259911 30.61294,9.3859911 30.24894,8.9709911 26.300932,4.475996 21.247922,1.9999981 16.020912,1.9999981 10.773902,1.9999981 5.7068925,4.4919958 1.7528849,9.0169916 1.5558844,9.2429914 1.2778835,9.3589907 0.99988365,9.3589907 0.76588249,9.3589907 0.53088284,9.2779913 0.34188175,9.1119909 -0.074118614,8.748992 -0.11611843,8.116992 0.24688148,7.7009926 4.5868902,2.7349977 10.187901,0 16.020912,0z" />
                </g>
              </svg>
            </div>

          </div>
        </mat-list>
      </div>
      <div fxLayout="column"  fxFlexAlign="center" class="downscrollarrow" style="margin-top:-4px;">
        <button mat-button class="arrowbtn" (click)="ScrollDown()" *ngIf="DownScrolling()">
          <img src="/assets/general/arrow_scroll.svg">
        </button>
      </div>
    </div>

    <div class="divOR"><span>{{'COMMON.OR' | i18next }}</span></div>
    <div fxLayout="column" class="qrCodeSelection">
      <p class="filterheadertext">{{'COMPONENTS.MODULEONBOARDINGTAB.SCANQR' | i18next }}</p>
      <p *ngIf="!scannerEnabled" class="camInfoText">{{'COMPONENTS.MODULEONBOARDINGTAB.ACTIVATECAM' | i18next }}</p>
      <mat-progress-spinner *ngIf="showWaitScreen"  class="spinner" mode="indeterminate"></mat-progress-spinner>
      <zxing-scanner #scanner
                     (click)="ActiveDeactivateScanner()"
                     [enable]="scannerEnabled"
                     (scanSuccess)="scanSuccessHandler($event)"
                     [(device)]="currentDevice"
                     (camerasFound)="onCamerasFound($event)">
      </zxing-scanner>
      <p class="currentCam" *ngIf="currentIndex>=0">CAM: {{this.availableDevices[currentIndex].label}}</p>
      <button (click)="switchCam()" type="button" class="btn-success switchCam"></button>
    </div>

  </div>

  <div class="resultDiv" fxLayout="row" fxFlexAlign="stretch">
    <div *ngIf="_modulePlan.customerModule.SerialNumber" class="selected" fxLayout="row" fxFlexAlign="center">
      <p class="label">{{'COMPONENTS.MODULEONBOARDINGTAB.SELECTEDSERIAL' | i18next }}</p>
      <p class="info">{{_modulePlan.customerModule.SerialNumber}}</p>
    </div>
  </div>

  <div fxLayout="row" fxFlexAlign="center" class="buttondiv">
    <button class="retryButton" mat-button (click)="RetryInit()" *ngIf="RetryPossible()">
      {{'COMMON.RETRY' | i18next }}
    </button>
    <button class="retryButton" mat-button (click)="changeSerial()" *ngIf="_modulePlan.customerModule.SerialNumberSetted">
      {{'COMPONENTS.MODULEONBOARDINGTAB.CHANGESERIAL' | i18next }}
    </button>
  </div>


  <section class="logsection" fxLayout="column" *ngIf="_modulePlan.customerModule.SerialNumberSetted">
    <div fxLayout="row">
      <p class="detailheader">Details</p>
      <svg class="updownicon" *ngIf="!showLog" xmlns="http://www.w3.org/2000/svg" height="25" width="25" viewBox="0 0 4.58 9.16" (click)="showLog = !showLog">
        <defs>
          <style>.cls-1{fill:#1eb4eb;}</style>
        </defs>
        <title>clap</title>
        <g id="Ebene_2" data-name="Ebene 2">
          <g id="Bearbeiten_S4" data-name="Bearbeiten S4">
            <polygon class="cls-1" points="0 9.16 0 0 4.58 4.58 0 9.16"/>
          </g>
        </g>
      </svg>
      <svg class="updownicon" *ngIf="showLog" xmlns="http://www.w3.org/2000/svg" height="25" width="25" viewBox="0 0 9.16 4.58" (click)="showLog = !showLog">
        <defs>
          <style>.cls-1{fill:#1eb4eb;}</style>
        </defs>
        <title>unclap</title>
        <g id="Ebene_2" data-name="Ebene 2">
          <g id="Bearbeiten_S4" data-name="Bearbeiten S4">
            <polygon class="cls-1" points="0 0 9.16 0 4.58 4.58 0 0"/>
          </g>
        </g>
      </svg>
    </div>
    <div fxLayout="column" class="logview" *ngIf="showLog" #logdiv>
      <div fxLayout="column" *ngFor="let l of getLogMessages()">
        <p [ngClass]="{'pInfo': l.LogType === 0, 'pWarn': l.LogType === 1, 'pError': l.LogType === 2}">{{l.Text}}</p>
      </div>
    </div>
  </section>

  <div class="pleasewait" *ngIf="showWaitScreen">

  </div>

</section>
